import mixin from './mixin';
import { userStore } from './store/userStore.js';
import subscriptionComponent from './components/SubscriptionComponent.vue';

const subscriptionApp = {
    components: { subscriptionComponent },
    mixins: [mixin],
    data() {
        return {
            plansApi: '',
            plans: [],
            culture: 'nl-NL',
            loading: false,
        }
    },
    computed: {
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    methods: {
        async init() {
            this.loading = true;
            const plansResponse = await this.fetchApiData(this.plansApi + '?cultureCode=' + this.culture, '', 'get');
            if (plansResponse && plansResponse.status === 200) {
                this.plans = plansResponse.data.map(plan => ({
                    ...plan,
                    userSubscribed: this.user.activeSubscription ? this.user.activeSubscription.subscriptionId === plan.id : false,
                    planEndDate: this.user.activeSubscription ? this.user.activeSubscription.subscriptionId === plan.id ? this.user.activeSubscription.end : null : null
                }));
            }
            this.loading = false;
        }
    },
    mounted() {
        if (this.$el.dataset.api) this.plansApi = this.$el.dataset.api;
        if (this.$el.dataset.culture) this.culture = this.$el.dataset.culture;
        this.init();
    }
}

export default subscriptionApp;